import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { WOMEN_APPAREL_PATH_IDENTIFIER } from "@faire/retailer-shared/categories/pathIdentifier";
import { SHOWROOM_CATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { findActiveCategoryByUrlIds } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore/findByUrlId";
import { LOGGED_OUT_CATEGORY_PAGE_APPAREL_FAQS, trackFaqClick } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageBelowResults/LoggedOutCategoryPageFAQs/__internal__/LoggedOutCategoryPageApparelFAQsContent";
import { getC1CategoryFAQs } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageBelowResults/LoggedOutCategoryPageFAQs/__internal__/LoggedOutCategoryPageFAQsContent";
import { VisibilityTracker } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/VisibilityTracker";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Accordion } from "@faire/web--source/slate/Accordion";
import { Spacer } from "@faire/web--source/slate/spacing";
import { trackSeoLoggedOutCategoryPageC1Click } from "@faire/web-api--source/events/seo/click/loggedOutCategoryPageC1";
import isChromatic from "chromatic/isChromatic";
import shuffle from "lodash/shuffle";
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
var MAX_NUMBER_OF_C2 = 5;
export var LoggedOutCategoryPageFAQs = function() {
    var _categoryModel_urlId;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var categories = useCategoryStore().categories;
    var categoryModel = useLoggedOutCategoryPageCurrentCategory();
    var history = useHistory();
    var _categoryModel_urlIdStrings;
    var categoryUrlIds = (_categoryModel_urlIdStrings = categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.urlIdStrings) !== null && _categoryModel_urlIdStrings !== void 0 ? _categoryModel_urlIdStrings : [];
    var showApparelFAQs = (categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.mostSpecificPathIdentifier) === WOMEN_APPAREL_PATH_IDENTIFIER;
    var isShowroomCategoryRoute = (categoryModel === null || categoryModel === void 0 ? void 0 : (_categoryModel_urlId = categoryModel.urlId) === null || _categoryModel_urlId === void 0 ? void 0 : _categoryModel_urlId.id) === SHOWROOM_CATEGORY_URL_ID;
    var category = findActiveCategoryByUrlIds(categoryUrlIds, categories);
    var subCategories = useMemo(function() {
        var subCategories = category === null || category === void 0 ? void 0 : category.sub_categories;
        if (!(subCategories === null || subCategories === void 0 ? void 0 : subCategories.length)) {
            return [];
        }
        var shuffledSubCategories = isChromatic() ? subCategories : shuffle(subCategories);
        return shuffledSubCategories.slice(0, Math.min(MAX_NUMBER_OF_C2, shuffledSubCategories.length));
    }, [
        category === null || category === void 0 ? void 0 : category.sub_categories
    ]);
    var C1CategoryFAQs = useMemo(function() {
        if (!category) {
            return [];
        }
        return getC1CategoryFAQs(history, category, subCategories, strictLocalize);
    }, [
        history,
        category,
        strictLocalize,
        subCategories
    ]);
    var shouldRenderFAQ = useMemo(function() {
        // only C1 will have FAQs
        return showApparelFAQs || (categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.isPrimaryCategory) && !(categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.isAllBrands) && !isShowroomCategoryRoute;
    }, [
        showApparelFAQs,
        categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.isPrimaryCategory,
        categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.isAllBrands,
        isShowroomCategoryRoute
    ]);
    var LOGGED_OUT_CATEGORY_PAGE_APPAREL_FAQS_OBJECT = useMemo(function() {
        return LOGGED_OUT_CATEGORY_PAGE_APPAREL_FAQS(history);
    }, [
        history
    ]);
    if (!shouldRenderFAQ || category === undefined) {
        return /*#__PURE__*/ _jsx(Spacer, {
            height: "5x"
        });
    }
    if (showApparelFAQs) {
        return /*#__PURE__*/ _jsxs(VisibilityTracker, {
            name: "apparel-faq",
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "10x"
                }),
                /*#__PURE__*/ _jsx(Accordion, {
                    items: LOGGED_OUT_CATEGORY_PAGE_APPAREL_FAQS_OBJECT,
                    onItemClick: trackFaqClick
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "10x"
                })
            ]
        });
    } else {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "10x"
                }),
                /*#__PURE__*/ _jsx(Accordion, {
                    initiallyOpenIndex: 0,
                    items: C1CategoryFAQs,
                    onItemClick: function(index) {
                        return trackSeoLoggedOutCategoryPageC1Click(index.toString());
                    }
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "10x"
                })
            ]
        });
    }
};
